module.exports = __webpack_public_path__ + "static/media/work.803ef0f1.png";